import { createSlice } from '@reduxjs/toolkit';

import { handleGetOrganizations } from './actions';
import { IOrganizationsState } from './slice.interface';

const initialState: IOrganizationsState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const organizationSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    removeOrganizations: (state: IOrganizationsState) => {
      state.data = [];
      state.isLoading = false;
      state.isReady = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetOrganizations.pending, (state: IOrganizationsState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetOrganizations.rejected, (state: IOrganizationsState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetOrganizations.fulfilled, (state: IOrganizationsState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
        state.isReady = true;
      });
  },
});

export const { removeOrganizations } = organizationSlice.actions;

export default organizationSlice.reducer;
